// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"42":"25c625140e1884d29d10","702":"83e63b16c6c1c616ff02","715":"e5f6a30da1195a504494","934":"dd31a89404bec545949f"}[chunkId] + ".css";
};